export const frontmatter = {
  title: "Launchpad",
  order: 15,
}

## Launchpad

We provide a tailored launchpad service to upcoming projects that want to launch their tokens directly. This service leverages the SeedR platform to enable custom solutions such as LBPs, TGEs, LGEs, IDOs, IFOs and more!

- [Open a ticket on Discord](https://discord.gg/PqggXcYtYS) to start your journey with us!
